import {
  AgxTypography,
  AgxCollapsible,
  AgxSpacer,
} from '@urbanx/agx.ui-components2'
import { JSX } from 'react'

interface SubPagePanelProps {
  panelTitle?: string
  expandable?: boolean
  customTitle?: JSX.Element
  children: React.ReactNode
  defaultExpanded?: boolean
}

export function SubPagePanel({
  panelTitle,
  children,
  customTitle,
  expandable = false,
  defaultExpanded = false,
}: SubPagePanelProps) {
  return (
    <>
      {expandable ? (
        <AgxCollapsible
          iconPosition="right"
          enableToggle={true}
          open={defaultExpanded}
          variant={'withDivider'}
          content={<>{children}</>}
          customTitle={
            customTitle != null ? (
              customTitle
            ) : (
              <AgxTypography
                id={`panelTitle_${panelTitle}`}
                type="title"
                size="large"
                color="var(--text-primary)"
              >
                {panelTitle}
              </AgxTypography>
            )
          }
        ></AgxCollapsible>
      ) : (
        <div className="panelContainer fill">
          <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
            <div className="panelTitle">
              <AgxTypography
                id={`panelTitle_${panelTitle}`}
                type="body_ui_strong"
                size="medium"
              >
                {panelTitle}
              </AgxTypography>
            </div>
            <div className="panelTitleContainer">{children}</div>
          </AgxSpacer>
        </div>
      )}
    </>
  )
}
